import React from 'react';
import { MessageCircle, BookOpen } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const PublishWithUs = () => {
  const whatsappNumber = '542604801102';
  const whatsappMessage = encodeURIComponent('Hola, quiero publicar mi libro con Raíz Lecturas. Te cuento de qué va.');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section className="py-24 bg-gradient-to-b from-white to-amber-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              ¿Te gustaría publicar libros con nosotros?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto mb-8"></div>
          </div>

          {/* Main Content Card */}
          <Card className="shadow-2xl border-none bg-white mb-12">
            <CardContent className="p-8 md:p-12">
              <div className="flex items-start space-x-4 mb-8">
                <div className="bg-amber-100 p-3 rounded-full flex-shrink-0">
                  <BookOpen className="text-amber-700" size={32} />
                </div>
                <div>
                  <p className="text-xl text-gray-700 leading-relaxed mb-6">
                    En Raíz Lecturas acompañamos autores serios que quieren llevar su mensaje al mundo con calidad y honestidad. Si tenés un manuscrito listo o casi listo sobre conciencia, crecimiento interior, Cábala aplicada o temas afines, podemos ayudarte a pulirlo y publicarlo.
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="text-center pt-6 border-t border-gray-200">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center space-x-3 bg-gradient-to-r from-amber-600 to-amber-800 hover:from-amber-700 hover:to-amber-900 text-white px-10 py-5 rounded-full text-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl"
                >
                  <MessageCircle size={28} />
                  <span>Quiero publicar mi libro</span>
                </a>
                <p className="text-gray-500 text-sm mt-4">Te responderemos por WhatsApp</p>
              </div>
            </CardContent>
          </Card>

          {/* Trust Badge */}
          <div className="text-center">
            <p className="text-lg text-gray-600 italic">
              "Trabajamos con autores que tienen algo real que decir"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};